import React from "react";
const Home = React.lazy(() => import("../pages/Home/Home"));
const Dashboard = React.lazy(() => import("../pages/Dashboard/Dashboard"));
const ReportData = React.lazy(() => import("../pages/Dashboard/ReportData"));
const ReportDataView = React.lazy(() => import("../pages/Dashboard/ReportDataView"));
const Alerts = React.lazy(() => import("../pages/Dashboard/Alerts"));
const HistoricData = React.lazy(() => import("../pages/Dashboard/historic_reports"));
// const FacilityMgmnt = React.lazy(() => import("../pages/Dashboard/FacilityMgmnt"));
// const ReportData = React.lazy(() => import("../pages/ReportData/ReportData"));

const routes = [
  {
    path: "/home",
    component: Dashboard,
  },
  {
    path: "/reportdata",
    component:ReportData
  },
  {
    path: "/reportdataview",
    component:ReportDataView
  },
  {
    path: "/alerts",
    component:Alerts
  },
  {
    path: "/historicreports",
    component: HistoricData
  },
  // {
  //   path: "/facilitymgmnt",
  //   component: FacilityMgmnt
  // },
  {
    default: "/",
    path: "/",
    component: Dashboard,
  }
];

export default routes;
